module.exports = __webpack_public_path__ + "static/media/Desktop_Activity.134e7958.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/haf/Desktop_Activity.png
// module id = 83
// module chunks = 0